import { Button } from "@business-finland/wif-ui-lib";
import { useTranslation } from "next-i18next";
import { useCallback } from "react";

import { getCompanyFormClsx, getCompanyFormId } from "../helpers";
import {
  useCompanyFormState,
  useCompanyFormDispatch,
  companyFormActions,
} from "../store";

export default function CompanyFormActions() {
  const { t } = useTranslation();
  const { currentStep, isLoading } = useCompanyFormState();
  const dispatch = useCompanyFormDispatch();

  const onCancel = useCallback(() => {
    dispatch(companyFormActions.cancel());
  }, [dispatch]);

  return (
    <div
      id={getCompanyFormId("actions")}
      className={getCompanyFormClsx(
        "main",
        "buttons",
        currentStep === 1 && "hidden"
      )}
    >
      <Button.Secondary
        text={t("form.cancel")}
        disabled={isLoading}
        onClick={onCancel}
      />
      <Button.Primary
        type="submit"
        text={isLoading ? t("form.submitting") : t("form.submit")}
        disabled={isLoading}
      />
    </div>
  );
}
